import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=39a0080a&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=39a0080a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a0080a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39a0080a')) {
      api.createRecord('39a0080a', component.options)
    } else {
      api.reload('39a0080a', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=39a0080a&scoped=true&", function () {
      api.rerender('39a0080a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2WWJMtdgL0Dkj/JS/comp/GuestBox.vue"
export default component.exports